import { Palette } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/config/palette-config';
import { useThemeContext } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/config/theme-provider';

export const UnderAccent = () => {
  const { palette } = useThemeContext();

  switch (palette) {
    case Palette.Bridebook:
    case Palette.BridebookGreen:
    case Palette.BridebookBlush:
      return (
        <div className="absolute inset-0 hidden @screen-lg:block">
          <div className="sticky top-0 h-[var(--desktop-height,100vh)] w-full">
            <SwirlTopRight className="absolute top-0 right-0 text-[var(--ww-palette-accent)]" />
            <SwirlBottomLeft className="absolute bottom-0 left-0 text-[var(--ww-palette-accent)]" />
            <SwirlBottomRight className="absolute right-0 bottom-0 text-[var(--ww-palette-accent)]" />
          </div>
        </div>
      );
    default:
      return null;
  }
};

const SwirlBottomLeft = ({ className }: { className?: string }) => (
  <svg
    width={176}
    height={228}
    viewBox="0 0 176 228"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}>
    <path
      d="M0 0C40.1575 7.48954 84.3399 21.8202 118.698 63.501C148.794 100.01 167.416 152.757 175.476 227.586H94.9463C87.4083 166.524 72.5957 133.346 56.9678 114.388C42.7434 97.1318 24.7906 87.9123 0 81.792V0Z"
      fill="currentColor"
    />
  </svg>
);

const SwirlTopRight = ({ className }: { className?: string }) => (
  <svg
    width={802}
    height={360}
    viewBox="0 0 802 360"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}>
    <path
      d="M91.2529 0C94.9607 6.16114 98.9915 12.6301 103.368 19.417C151.403 93.9042 188.296 123.178 216.006 133.81C241.994 143.781 266.876 140.073 300.561 128.014C365.811 104.654 463.575 44.1299 592.129 118.938C648.233 151.585 693.438 183.467 732.881 212.515C758.018 231.027 780.025 247.77 801.092 263.012V359.972C798.831 358.529 796.574 357.072 794.321 355.599C758.799 332.371 723.158 304.706 685.442 276.931C647.099 248.693 604.483 218.686 551.894 188.083C463.06 136.389 409.27 174.068 327.525 203.333C287.713 217.586 240.237 228.794 187.348 208.501C136.18 188.869 87.6756 142.698 36.1348 62.7734C21.46 40.0172 9.42218 19.1519 0 0H91.2529ZM801.092 84.8516C788.588 69.7085 777.016 54.5197 766.798 39.4248C758.364 26.9659 750.314 13.7386 743.297 0H801.092V84.8516Z"
      fill="currentColor"
    />
  </svg>
);

const SwirlBottomRight = ({ className }: { className?: string }) => (
  <svg
    width={423}
    height={219}
    viewBox="0 0 423 219"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}>
    <path
      d="M370.397 1.56836C387.456 -1.21483 405.648 0.0253157 422.972 2.80078V84.1777C403.49 80.0432 390.801 79.2973 383.279 80.5244C381.622 80.7948 380.597 81.1052 380.034 81.3154C378.804 84.1859 376.157 94.9355 380.975 121.107C387.086 154.307 385.247 188.162 363.381 213.188C361.739 215.067 360.041 216.829 358.296 218.482H172.237C158.9 214.395 145.876 210.252 133.912 206.559C116.368 201.143 101.315 196.77 88.8662 193.954C92.3779 200.962 96.9205 209.096 102.646 218.482H11.9922C11.9111 218.299 11.8292 218.117 11.749 217.935C5.85204 204.522 1.29875 190.642 0.233398 177.037C-0.871219 162.93 1.64617 145.624 14.2207 131.282C26.3003 117.505 42.1222 112.869 53.7354 111.346C65.4399 109.811 77.4439 110.783 88.0234 112.383C109.193 115.583 134.026 122.868 157.509 130.117C182.15 137.724 206.246 145.6 229.732 151.881C253.41 158.212 273.032 161.93 287.816 162.152C297.324 162.295 301.552 160.975 303.038 160.333C303.771 158.187 305.204 151.383 302.297 135.591C296.331 103.179 295.918 72.6286 307.491 47.5771C320.697 18.9923 345.418 5.6438 370.397 1.56836Z"
      fill="currentColor"
    />
  </svg>
);
